import Lottie from "lottie-react";
import { arrowDown, usa, turkey, china } from "../../../assets/landing";
import BoldTextLanding from "../../../components/atoms/LandingText/BoldtextLanding";
import LightTextLanding from "../../../components/atoms/LandingText/LightTextLanding";
import TryOut from "../../../components/atoms/TryOut/TryOut";
import { useContent, useLanguages } from "../../../hooks/content";
import AskedQuestions from "../Delivery/helpers/AskedQuestions";
import { Returntext } from "../common/returnText";
import "../landingGlobal.scss";
import Benefits from "./helpers/Benefits";
import SimpleDelivery from "./helpers/SimpleDelivery";
import WhyUs from "./helpers/WhyUs";
import "./prices.scss";
import arrows from "../../../assets/animations/Arrow/data.json";
import { ReactComponent as Truck } from "../../../icons/truck.svg";
import { ReactComponent as Airplane } from "../../../icons/airplane.svg";
function Prices() {
  const { lang } = useLanguages();
  const { contentManagementData } = useContent();
  return (
    <>
      <div className="container_inside prices">
        <Lottie
          animationData={arrows}
          loop={false}
          style={{
            width: "100%",
            height: "100%",
            position: "absolute",
          }}
        />
        <div className="prices_texts">
          <LightTextLanding
            text={Returntext(contentManagementData, "prices_title", lang)}
            text_color="#000000"
            text_size="48px"
          />
          <div className="flex_start_between cent animation_container pricesPare">
            <div className="flagItem">
              <div className="new">
                <BoldTextLanding
                  text_color="#ffffff"
                  text={Returntext(contentManagementData, "new", lang)}
                  text_size="12px"
                />
              </div>
              <BoldTextLanding
                text_color="#000000"
                text={Returntext(
                  contentManagementData,
                  "prices_flags_country_china",
                  lang
                )}
                text_size="24px"
              />
              <img alt="" src={china} width={"72px"} loading="lazy" />
              {/* ChinaAir ChinaLand  ChinaLandTxt ChinaAirTxt*/}
              <div className="parentChina">
                <div className="childChina">
                  <BoldTextLanding
                    text_color="#000000"
                    text={Returntext(contentManagementData, "ChinaLand", lang)}
                    text_size="32px"
                  />
                  <div className="iconAndTXT">
                    <Truck
                      style={{
                        width: "13px",
                        height: "10.4px",
                        display: "block",
                      }}
                    />

                    <p
                      className="lightText"
                      style={{
                        color: "#000000",
                        fontSize: "13px",
                        lineHeight: "normal",
                      }}
                    >
                      {Returntext(contentManagementData, "ChinaLandTxt", lang)}
                    </p>
                  </div>
                </div>

                <div className="childChina">
                  <BoldTextLanding
                    text_color="#000000"
                    text={Returntext(contentManagementData, "ChinaAir", lang)}
                    text_size="32px"
                  />
                  <div className="iconAndTXT">
                    <Airplane style={{ width: "13px", height: "10.4px" }} />
                    <p
                      className="lightText"
                      style={{
                        color: "#000000",
                        fontSize: "13px",
                        lineHeight: "normal",
                      }}
                    >
                      {Returntext(contentManagementData, "ChinaAirTxt", lang)}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="flagItem">
              <BoldTextLanding
                text_color="#000000"
                text={Returntext(
                  contentManagementData,
                  "prices_flags_country_usa",
                  lang
                )}
                text_size="24px"
              />
              <img alt="" src={usa} width={"72px"} loading="lazy" />
              <BoldTextLanding
                text={Returntext(
                  contentManagementData,
                  "prices_USD_price",
                  lang
                )}
                text_color="#000000"
                text_size="35px"
              />

              <div
                className="iconAndTXT"
                style={{ margin: " 10px auto 0px", width: "50%" }}
              >
                <Airplane style={{ width: "13px", height: "10.4px" }} />
                <p
                  className="lightText"
                  style={{
                    color: "#000000",
                    fontSize: "13px",
                    lineHeight: "normal",
                  }}
                >
                  {Returntext(contentManagementData, "ChinaAirTxt", lang)}
                </p>
              </div>
            </div>

            <div className="flagItem">
              <div className="soon">
                <BoldTextLanding
                  text_color="#000000"
                  text={Returntext(contentManagementData, "prices_soon", lang)}
                  text_size="12px"
                />
              </div>

              <BoldTextLanding
                text_color="#000000"
                text={Returntext(
                  contentManagementData,
                  "prices_flags_country_turkey",
                  lang
                )}
                text_size="24px"
              />

              <img alt="" src={turkey} width={"72px"} loading="lazy" />

              <div
                className="iconAndTXT"
                style={{ margin: " 10px auto 0px", width: "50%" }}
              >
                <Truck
                  style={{
                    width: "13px",
                    height: "10.4px",
                    display: "block",
                  }}
                />

                <p
                  className="lightText"
                  style={{
                    color: "#000000",
                    fontSize: "13px",
                    lineHeight: "normal",
                  }}
                >
                  {Returntext(contentManagementData, "ChinaLandTxt", lang)}
                </p>
              </div>
            </div>
          </div>
        </div>
        <img alt="" src={arrowDown} loading="lazy" />
      </div>
      <WhyUs />
      <Benefits />
      <SimpleDelivery />
      <AskedQuestions showGreenPart={false} />

      <TryOut />
    </>
  );
}

export default Prices;
